import React from "react";
import {
    AdditionalChecklistBlockData,
    DEFAULT_ADDITIONAL_CHECKLIST_BLOCK_DATA,
} from "models/interfaces/additional-block-data/additional-checklist-block-data";
import { ReadonlyPageBlockProps } from "organisms/page-blocks/readonly-page-block/readonly-page-block";
import { ReadonlyPageBlockContent } from "organisms/page-blocks/readonly-page-block/readonly-page-block-content";
import { useChecklistBlockChecklistItems } from "utilities/hooks/domain/block-configurations/use-checklist-block-checklist-items";
import useReadonlyChecklistEditGuard from "utilities/hooks/domain/notebooks/pages/checklists/use-readonly-checklist-edit-guard";

interface ReadonlyChecklistPageBlockProps extends ReadonlyPageBlockProps {
    recipientGuid?: string;
    sharedPageGuid?: string;
}

export const ReadonlyChecklistPageBlock: React.FC<
    ReadonlyChecklistPageBlockProps
> = (props: ReadonlyChecklistPageBlockProps): JSX.Element => {
    const { items, updateItems, isLoadingItems } =
        useChecklistBlockChecklistItems(props.block.configuration);
    const { guardAction } = useReadonlyChecklistEditGuard(
        props.block.pageId,
        props.block.id,
        props.onRequestEditMode
    );

    const additionalBlockData: AdditionalChecklistBlockData = {
        ...DEFAULT_ADDITIONAL_CHECKLIST_BLOCK_DATA,
        guardAction,
        isLoadingItems,
        items: items,
        updateItems,
    };

    return (
        <ReadonlyPageBlockContent
            {...props}
            additionalBlockData={additionalBlockData}
        />
    );
};
